import { IMPORTED_CHECK_STATUS } from "../../../constants";

// Booking group status (campgroup_booking_meta.status, free text). The four
// Gantt colours come from the 2027 Gantt workbook. DRAFT and INVOICED keep
// their stored values and are relabelled, so existing groups need no change.
// The backend's BookingGanttCalculator.ganttStatus must agree with ganttStatus.

export const GANTT_STATUSES = [
  { key: "NEEDS_ACTION", label: "Needs action", color: "#00CCFF" },
  { key: "SPACE_HELD", label: "Space held", color: "#FFFF00" },
  { key: "INVOICED_DEPOSIT", label: "Invoiced deposit", color: "#FF9900" },
  { key: "DEPOSIT_PAID", label: "Deposit paid", color: "#00B050" },
];

const GANTT_BY_KEY = Object.fromEntries(GANTT_STATUSES.map((s) => [s.key, s]));

/** What the status dropdown offers, in order. */
export const BOOKING_STATUS_OPTIONS = [
  { value: IMPORTED_CHECK_STATUS, label: IMPORTED_CHECK_STATUS },
  { value: "DRAFT", label: "Needs action" },
  { value: "SPACE_HELD", label: "Space held" },
  { value: "INVOICED", label: "Invoiced deposit" },
  { value: "DEPOSIT_PAID", label: "Deposit paid" },
  { value: "CONFIRMED", label: "Confirmed" },
  { value: "COMPLETE", label: "Complete" },
  { value: "CANCELLED", label: "Cancelled" },
];

const LABELS = Object.fromEntries(BOOKING_STATUS_OPTIONS.map((o) => [o.value, o.label]));

/** Display label for a stored status; unknown values show as stored. */
export function statusLabel(status) {
  if (!status) return "";
  return LABELS[status] || status;
}

/** Gantt colour key for a stored status, or null when cancelled (not drawn). */
export function ganttStatus(status) {
  const s = String(status || "").trim().toUpperCase().replace(/ /g, "_");
  switch (s) {
    case "CANCELLED":
      return null;
    case "SPACE_HELD":
      return "SPACE_HELD";
    case "INVOICED":
    case "INVOICED_DEPOSIT":
      return "INVOICED_DEPOSIT";
    case "DEPOSIT_PAID":
    case "CONFIRMED":
    case "COMPLETE":
      return "DEPOSIT_PAID";
    default:
      return "NEEDS_ACTION";
  }
}

/** { key, label, color } for a Gantt status key (falls back to Needs action). */
export function ganttMeta(key) {
  return GANTT_BY_KEY[key] || GANTT_BY_KEY.NEEDS_ACTION;
}
